// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact {
    text-align: right;
    margin: 0;
    padding: 0;
}
/* Alinha os itens à direita em telas maiores */
.custom-align {
    margin-left: auto;
}

/* Para telas pequenas, o conteúdo deve ser alinhado à esquerda */
@media (max-width: 576px) {
    .navbar-nav {
        justify-content: flex-start; /* Alinha todos os itens à esquerda */
    }

    .user-info {
        text-align: left; /* Garante que o conteúdo vai para a esquerda */
    }
}

.bg-light-lg {
    background-color: #ffffff !important; /* Sobrescreve a cor de fundo com uma sólida */
}

.dropdown-menu-light {
    background-color: #f8f9fa !important; /* Define uma cor sólida para o dropdown */
}


/* .nav-link.active {
    font-weight: bold;
} */

/* Estilos compactos para controle de Ano Base na navbar */
.navbar-year-input {
    height: 28px;
    padding: 0.18rem 0.4rem;
    font-size: 0.85rem;
    line-height: 1;
}
.navbar-year-btn {
    height: 28px;
    padding: 0.15rem 0.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.navbar-year-input:focus {
    box-shadow: none;
}

/* Diminuir o tamanho das letras na navbar */
.navbar,
.navbar .nav-link,
.navbar .dropdown-item,
.navbar .navbar-brand,
.navbar .nav-item {
    font-size: 0.9rem;
}

@media (max-width: 576px) {
    .navbar,
    .navbar .nav-link,
    .navbar .dropdown-item,
    .navbar .navbar-brand,
    .navbar .nav-item {
        font-size: 0.85rem;
    }
}

/* Reduzir altura da navbar e ajustar elementos internos */
.navbar {
    padding-top: 0.15rem;
    padding-bottom: 0.15rem;
    min-height: 40px;
}
.navbar .container-fluid {
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    align-items: center;
}
.navbar img.d-inline-block {
    width: 120px;
    height: 34px;
}
.navbar .nav-link {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    line-height: 1;
}

/* Ajustes para o novo elemento user-info (li) dentro da navbar */
.navbar .user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
}
.navbar .user-info .nav-link {
    padding: 0;
}

/* Garantir alinhamento vertical consistente dos itens da navbar */
.navbar .navbar-nav,
.navbar .navbar-nav .nav-item,
.navbar .navbar-nav > li {
    display: flex;
    align-items: center;
}

/* Forçar user-info a ter altura igual aos botões/itens da navbar */
.navbar .user-info {
    height: 40px; /* corresponde ao min-height da navbar */
    box-sizing: border-box;
}
.navbar .user-info .nav-link {
    display: inline-flex;
    align-items: center;
    height: 100%;
}

@media (max-width: 576px) {
    .navbar .user-info {
        align-items: flex-start;
        text-align: left;
    }
}
.navbar .navbar-toggler {
    padding: 0.2rem 0.4rem;
}
/* Controles de ano base na navbar */
.navbar .input-group .input-group-text,
.navbar .input-group .form-control {
  height: var(--acp-control-height) !important;
  min-height: var(--acp-control-height) !important;
  max-height: var(--acp-control-height) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
}
.navbar .input-group .input-group-text {
  padding-left: 0.35rem !important;
  padding-right: 0.35rem !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.navbar .input-group .input-group-text i {
  font-size: 10px !important;
  line-height: 1 !important;
}
.navbar .input-group .form-control {
  padding-left: 0.4rem !important;
  padding-right: 0.4rem !important;
  font-size: 0.82rem !important;
  text-align: center;
}

@media (max-width: 576px) {
    .navbar {
        min-height: 44px;
    }
}

.navbar .dropdown-menu {
    background: linear-gradient(90deg, #0b3383, #0e48ad) !important;
    border-color: rgba(255, 255, 255, 0.15) !important;
}
.navbar .dropdown-menu .dropdown-item {
    color: #fff !important;
}
.navbar .dropdown-menu .dropdown-item:hover,
.navbar .dropdown-menu .dropdown-item:focus {
    color: #fff !important;
    background-color: rgba(255, 255, 255, 0.15) !important;
}
.navbar .dropdown-menu .dropdown-item.active {
    color: #fff !important;
    background-color: rgba(255, 255, 255, 0.2) !important;
    font-weight: 600;
}
.navbar .nav-link.active {
    color: #fff !important;
    font-weight: 600;
    border-bottom: 2px solid rgba(255, 255, 255, 0.6);
}
.navbar .dropdown-menu .nav-link {
    color: #fff !important;
}
.navbar .dropdown-menu .dropdown-divider {
    border-color: rgba(255, 255, 255, 0.2) !important;
}`, "",{"version":3,"sources":["webpack://./src/service/css/Navbar.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;AACA,+CAA+C;AAC/C;IACI,iBAAiB;AACrB;;AAEA,iEAAiE;AACjE;IACI;QACI,2BAA2B,EAAE,qCAAqC;IACtE;;IAEA;QACI,gBAAgB,EAAE,+CAA+C;IACrE;AACJ;;AAEA;IACI,oCAAoC,EAAE,8CAA8C;AACxF;;AAEA;IACI,oCAAoC,EAAE,0CAA0C;AACpF;;;AAGA;;GAEG;;AAEH,0DAA0D;AAC1D;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;;AAEA,4CAA4C;AAC5C;;;;;IAKI,iBAAiB;AACrB;;AAEA;IACI;;;;;QAKI,kBAAkB;IACtB;AACJ;;AAEA,0DAA0D;AAC1D;IACI,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;;AAEA,kEAAkE;AAClE;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA,mEAAmE;AACnE;IACI,YAAY,EAAE,wCAAwC;IACtD,sBAAsB;AAC1B;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;QACvB,gBAAgB;IACpB;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA,oCAAoC;AACpC;;EAEE,4CAA4C;EAC5C,gDAAgD;EAChD,gDAAgD;EAChD,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,+DAA+D;IAC/D,kDAAkD;AACtD;AACA;IACI,sBAAsB;AAC1B;AACA;;IAEI,sBAAsB;IACtB,sDAAsD;AAC1D;AACA;IACI,sBAAsB;IACtB,qDAAqD;IACrD,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iDAAiD;AACrD;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,iDAAiD;AACrD","sourcesContent":[".compact {\r\n    text-align: right;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n/* Alinha os itens à direita em telas maiores */\r\n.custom-align {\r\n    margin-left: auto;\r\n}\r\n\r\n/* Para telas pequenas, o conteúdo deve ser alinhado à esquerda */\r\n@media (max-width: 576px) {\r\n    .navbar-nav {\r\n        justify-content: flex-start; /* Alinha todos os itens à esquerda */\r\n    }\r\n\r\n    .user-info {\r\n        text-align: left; /* Garante que o conteúdo vai para a esquerda */\r\n    }\r\n}\r\n\r\n.bg-light-lg {\r\n    background-color: #ffffff !important; /* Sobrescreve a cor de fundo com uma sólida */\r\n}\r\n\r\n.dropdown-menu-light {\r\n    background-color: #f8f9fa !important; /* Define uma cor sólida para o dropdown */\r\n}\r\n\r\n\r\n/* .nav-link.active {\r\n    font-weight: bold;\r\n} */\r\n\r\n/* Estilos compactos para controle de Ano Base na navbar */\r\n.navbar-year-input {\r\n    height: 28px;\r\n    padding: 0.18rem 0.4rem;\r\n    font-size: 0.85rem;\r\n    line-height: 1;\r\n}\r\n.navbar-year-btn {\r\n    height: 28px;\r\n    padding: 0.15rem 0.5rem;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.navbar-year-input:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n/* Diminuir o tamanho das letras na navbar */\r\n.navbar,\r\n.navbar .nav-link,\r\n.navbar .dropdown-item,\r\n.navbar .navbar-brand,\r\n.navbar .nav-item {\r\n    font-size: 0.9rem;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .navbar,\r\n    .navbar .nav-link,\r\n    .navbar .dropdown-item,\r\n    .navbar .navbar-brand,\r\n    .navbar .nav-item {\r\n        font-size: 0.85rem;\r\n    }\r\n}\r\n\r\n/* Reduzir altura da navbar e ajustar elementos internos */\r\n.navbar {\r\n    padding-top: 0.15rem;\r\n    padding-bottom: 0.15rem;\r\n    min-height: 40px;\r\n}\r\n.navbar .container-fluid {\r\n    padding-top: 0;\r\n    padding-bottom: 0;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.navbar img.d-inline-block {\r\n    width: 120px;\r\n    height: 34px;\r\n}\r\n.navbar .nav-link {\r\n    padding-top: 0.25rem;\r\n    padding-bottom: 0.25rem;\r\n    line-height: 1;\r\n}\r\n\r\n/* Ajustes para o novo elemento user-info (li) dentro da navbar */\r\n.navbar .user-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n}\r\n.navbar .user-info .nav-link {\r\n    padding: 0;\r\n}\r\n\r\n/* Garantir alinhamento vertical consistente dos itens da navbar */\r\n.navbar .navbar-nav,\r\n.navbar .navbar-nav .nav-item,\r\n.navbar .navbar-nav > li {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n/* Forçar user-info a ter altura igual aos botões/itens da navbar */\r\n.navbar .user-info {\r\n    height: 40px; /* corresponde ao min-height da navbar */\r\n    box-sizing: border-box;\r\n}\r\n.navbar .user-info .nav-link {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    height: 100%;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .navbar .user-info {\r\n        align-items: flex-start;\r\n        text-align: left;\r\n    }\r\n}\r\n.navbar .navbar-toggler {\r\n    padding: 0.2rem 0.4rem;\r\n}\r\n/* Controles de ano base na navbar */\r\n.navbar .input-group .input-group-text,\r\n.navbar .input-group .form-control {\r\n  height: var(--acp-control-height) !important;\r\n  min-height: var(--acp-control-height) !important;\r\n  max-height: var(--acp-control-height) !important;\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;\r\n  line-height: 1 !important;\r\n  box-sizing: border-box !important;\r\n}\r\n.navbar .input-group .input-group-text {\r\n  padding-left: 0.35rem !important;\r\n  padding-right: 0.35rem !important;\r\n  display: inline-flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n.navbar .input-group .input-group-text i {\r\n  font-size: 10px !important;\r\n  line-height: 1 !important;\r\n}\r\n.navbar .input-group .form-control {\r\n  padding-left: 0.4rem !important;\r\n  padding-right: 0.4rem !important;\r\n  font-size: 0.82rem !important;\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .navbar {\r\n        min-height: 44px;\r\n    }\r\n}\r\n\r\n.navbar .dropdown-menu {\r\n    background: linear-gradient(90deg, #0b3383, #0e48ad) !important;\r\n    border-color: rgba(255, 255, 255, 0.15) !important;\r\n}\r\n.navbar .dropdown-menu .dropdown-item {\r\n    color: #fff !important;\r\n}\r\n.navbar .dropdown-menu .dropdown-item:hover,\r\n.navbar .dropdown-menu .dropdown-item:focus {\r\n    color: #fff !important;\r\n    background-color: rgba(255, 255, 255, 0.15) !important;\r\n}\r\n.navbar .dropdown-menu .dropdown-item.active {\r\n    color: #fff !important;\r\n    background-color: rgba(255, 255, 255, 0.2) !important;\r\n    font-weight: 600;\r\n}\r\n.navbar .nav-link.active {\r\n    color: #fff !important;\r\n    font-weight: 600;\r\n    border-bottom: 2px solid rgba(255, 255, 255, 0.6);\r\n}\r\n.navbar .dropdown-menu .nav-link {\r\n    color: #fff !important;\r\n}\r\n.navbar .dropdown-menu .dropdown-divider {\r\n    border-color: rgba(255, 255, 255, 0.2) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
